// extracted by mini-css-extract-plugin
export var active = "index-module--active--1Z35P";
export var content = "index-module--content--SdTTE";
export var hasTabs = "index-module--hasTabs--yMd9h";
export var subTitle = "index-module--subTitle--dBJIO";
export var tab = "index-module--tab--tyzl1";
export var tabSwitcher = "index-module--tabSwitcher--wwEnx";
export var tabs = "index-module--tabs--zA64l";
export var title = "index-module--title--7dem7";
export var titleWrapper = "index-module--titleWrapper--0GUJh";